module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/review-graph-607d45dfab58e6546a3134da7365c106.png";